import React, { useState } from 'react';
import { KatButton } from '@amzn/katal-react';
import PSTriageAssistModal from './PSTriageAssistModal';
import { AiAssistDiagnosticResponse } from '../services/Ai/AiAssistService';

interface PSTriageAssistButtonProps {
    diagnosticCode: string;
    diagnosticDescription: string;
    sampleRefundIds: string[];
    count: number;
    job?: AiAssistDiagnosticResponse | null;
}

const PSTriageAssistButton: React.FC<PSTriageAssistButtonProps> = ({
    diagnosticCode,
    diagnosticDescription,
    sampleRefundIds,
    count,
    job,
}) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <KatButton
                variant="secondary"
                label="PSTriage Job"
                onClick={() => setIsOpen(true)}
                disabled={sampleRefundIds.length === 0}
            />
            <PSTriageAssistModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                diagnosticCode={diagnosticCode}
                diagnosticDescription={diagnosticDescription}
                sampleRefundIds={sampleRefundIds}
                count={count}
                job={job}
            />
        </>
    );
};

export default PSTriageAssistButton;
